module.exports = __webpack_public_path__ + "2141f523739a1a0cfad326606d871840.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/book-s.png
// module id = 1067
// module chunks = 0